import {
  EVENT_TYPE_ASSESSMENT,
  EVENT_TYPE_CONSULTATION,
  EVENT_TYPE_SCREENING,
  EVENT_TYPE_THERAPY_SESSION,
} from 'src/consumer/constants'
import { getSPDataWithParams, postSPDataWithParams } from './services'

export const MANAGEMENT_BOOKING_REPORTING_EVENT_TYPES = [
  EVENT_TYPE_THERAPY_SESSION,
  EVENT_TYPE_CONSULTATION,
  EVENT_TYPE_SCREENING,
  EVENT_TYPE_ASSESSMENT,
]

export const MANAGEMENT_BOOKING_REPORTING_FILTERS = {
  all: MANAGEMENT_BOOKING_REPORTING_EVENT_TYPES,
  therapy: [EVENT_TYPE_THERAPY_SESSION],
  consultation: [EVENT_TYPE_CONSULTATION],
  screening: [EVENT_TYPE_SCREENING],
  assessment: [EVENT_TYPE_ASSESSMENT],
}

function buildReportingParams({
  from,
  to,
  eventTypeFilter,
  dateDimension,
  referenceDate,
  ...extraParams
}) {
  const params = {}
  const eventTypes = MANAGEMENT_BOOKING_REPORTING_FILTERS[eventTypeFilter]

  if (from) {
    params.from = from
  }
  if (to) {
    params.to = to
  }
  if (eventTypes && eventTypes.length > 0) {
    params.eventTypes = eventTypes.join(',')
  }
  if (dateDimension) {
    params.dateDimension = dateDimension
  }
  if (referenceDate) {
    params.referenceDate = referenceDate
  }
  Object.entries(extraParams || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params[key] = value
    }
  })

  return params
}

export async function getManagementBookingReportingOverall(params) {
  return getSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/overall',
    buildReportingParams(params),
  )
}

export async function getManagementBookingReportingPractitioners(params) {
  return getSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/practitioners',
    buildReportingParams(params),
  )
}

export async function getManagementBookingReportingPractitionerRevenueDetails(params) {
  return getSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/practitioners/revenue-details',
    buildReportingParams(params),
  )
}

export async function getManagementBookingReportingClinicBrands(params) {
  return getSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/clinic-brands',
    buildReportingParams(params),
  )
}

export async function getManagementBookingReportingQuarterlySummary(params) {
  return getSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/quarterly-summary',
    buildReportingParams(params),
  )
}

export async function getManagementBookingReportingMonthlySummary(params) {
  return getSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/monthly-summary',
    buildReportingParams(params),
  )
}

export async function saveManagementBookingReportingSnapshot(params) {
  return postSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/save-current',
    {},
    buildReportingParams(params),
  )
}

export async function refreshManagementBookingReportingSnapshots() {
  return postSPDataWithParams(
    '/api/secure/cc/support/booking-reporting/refresh-completed-snapshots',
    {},
    {},
  )
}
